import styled from 'styled-components';

const SearsInputField = styled.input`
margin: ${props => props.margin ? props.margin : '0rem'};
padding: ${props => props.padding ? props.padding : '0px 0px 0px 10px'};
-webkit-appearance: none;
border-radius: 5px;
height: ${props => props.height ? props.height : '3em'};
min-height: ${props => props.height ? props.height : '34px'};
font-family: ${props => props.fontFamily ? props.fontFamily : 'Amx-Regular'};
font-weight: ${props => props.fontWeight ? props.fontWeight : ''};
color: ${props => props.color ? props.color : '#323232'};
font-size: ${props => props.fontSize ? props.fontSize : '0.7rem'};
line-height: ${props => props.lineHeight ? props.lineHeight : 'auto'};
vertical-align: ${props => props.verticalAlign ? props.verticalAlign : 'middle'};
border: ${props => props.border ? props.border : '1px solid #c4c4c4'};
background: ${props => props.background ? props.background : 'transparent'};
width: ${props => props.width ? props.width : 'auto'};
text-align: ${props => props.textAlign ? props.textAlign : 'left'};
outline: ${props => props.outline ? props.outline : 'none'}; 
flex-grow: ${props => props.flexGrow ? props.flexGrow : '1'};
max-width: 100%;
::placeholder {
    margin: ${props => props.margin ? props.margin : '0rem'};
    padding: ${props => props.padding ? props.padding : '0rem'};
    color: ${props => props.phColor ? props.phColor : '#c4c4c4'};
    font-size: ${props => props.fontSize ? props.fontSize : '0.7rem'};
    line-height: ${props => props.lineHeight ? props.lineHeight : 'auto'};
    vertical-align: ${props => props.verticalAlign ? props.verticalAlign : 'middle'};
    font-family: ${props => props.fontFamily ? props.fontFamily : 'Amx-Regular'};
    text-align: ${props => props.textAlign ? props.textAlign : 'left'};
    font-weight: ${props => props.fontWeight ? props.fontWeight : ''};
}
`
export default SearsInputField;